import {Card} from "antd";
import {useEffect, useState} from "react";
import {apiError, handleRequest} from "../../../utils";
import {requestDemoApi} from "../../../api";
import DOMPurify from "dompurify";
import RequestDemoFormComment from "./Forms/RequestDemoFormComment";

function RequestDemoComment({requestDemo})
{
    const [comments, setComments] = useState([])

    const eventsHandler = {
        load: async () => {

            let [error, response] = await handleRequest(requestDemoApi.comment({
                id: requestDemo.id
            }));

            let message = apiError(`Load câu trả lời cho requestDemo thất bại`, error, response);

            if (!message)
            {
                setComments(response.data);
            }
        },
    }

    function CommentTitle({comment}) {
        return <>
            <p>{comment.userName}</p>
            <p style={{fontSize:'13px', fontWeight:'normal'}}>{comment.created}</p>
        </>
    }

    useEffect(() => {
        eventsHandler.load().then()
    }, [requestDemo])

    return (
        <>
            {
                comments.length > 0 && comments.map((comment, index) => {
                    const color = comment.userIdType === 'customer' ? '#f50' : '#12356c';
                    return <Card title={<CommentTitle comment={comment} />} headStyle={{ backgroundColor: color, color: '#ffffff' }} className={'mt-1'} bodyPadding={1}>
                        <div style={{wordBreak : 'break-all'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(comment.message) }} />
                    </Card>
                })
            }
            <RequestDemoFormComment requestDemo={requestDemo} setComments={setComments} comments={comments} />
        </>

    )
}

export default RequestDemoComment;